"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const lexico_1 = __importDefault(require("@tradeshift/lexico"));
const react_router_1 = require("react-router");
const lexico = new lexico_1.default();
const ViewConversationButton = ({ approvalItem }) => {
    const navigate = (0, react_router_1.useNavigate)();
    return ((0, jsx_runtime_1.jsx)(material_1.Button, { variant: "contained", color: "secondary", style: {
            ...(globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP ? { textTransform: 'uppercase' } : {}),
        }, onClick: () => {
            // send the item to request page via router state when removing the flag
            void navigate(`/activity/${approvalItem.id}`);
        }, children: lexico.trc('Button', 'View conversation') }));
};
exports.default = ViewConversationButton;
